import { GenerateHelper } from "helpers";
import { isEmpty } from "lodash";
import moment from "moment";
import { applyMiddleware, compose, createStore } from "redux";
import { createLogger } from "redux-logger";
import { PersistConfig, persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import createSagaMiddleware from "redux-saga";
import { IdentityActions } from "redux/actions";
import i18n from "utils/i18n";
import rootReducers, { RootReducer } from "./rootReducer";
import rootSagas from "./rootSagas";

const config: PersistConfig<RootReducer> = {
  key: "root",
  timeout: 0,
  version: 1,
  storage: storage,
  debug: true,
  whitelist: ["IdentityReducer", "LanguageReducer"],
};
const sagaMiddleware = createSagaMiddleware();
const middleware = [];
middleware.push(sagaMiddleware);

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  middleware.push(createLogger());
} else {
  // production code
}
const reducers = persistReducer(config, rootReducers);
const enhancers = [applyMiddleware(...middleware)];
const persistConfig = { enhancers };
const store = createStore(reducers, undefined, compose(...enhancers));
const persistor = persistStore(store, persistConfig as any, () => {
  const stateData = store.getState();
  const language = stateData.LanguageReducer.language;
  moment.locale(language);
  i18n.changeLanguage(language);
  if (isEmpty(stateData.IdentityReducer.deviceId)) {
    const deviceId = GenerateHelper.getUUID();
    store.dispatch(IdentityActions.setDeviceId.request(deviceId));
  }
});
const configureStore = () => {
  return { persistor, store };
};
sagaMiddleware.run(rootSagas);
export default configureStore;
